var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 57,
    viewBox: "0 0 16 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7071 56.7071C8.31658 57.0976 7.68342 57.0976 7.29289 56.7071L0.92893 50.3431C0.538406 49.9526 0.538406 49.3195 0.92893 48.9289C1.31945 48.5384 1.95262 48.5384 2.34314 48.9289L8 54.5858L13.6569 48.9289C14.0474 48.5384 14.6805 48.5384 15.0711 48.9289C15.4616 49.3195 15.4616 49.9526 15.0711 50.3431L8.7071 56.7071ZM9 4.37114e-08L9 56L7 56L7 -4.37114e-08L9 4.37114e-08Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottom);
export default __webpack_public_path__ + "static/media/arrow_bottom.81ad097ab606a4f0defb98e32f774d4d.svg";
export { ForwardRef as ReactComponent };